import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { Label } from '../../atoms';
import styles from './UserManagementEventLoggingTemplate.module.css';
import cn from 'classnames';
import {
  UserManagementEventLogging,
  UserManagementEventLoggingFilterOrganism,
} from '../../organisms';
import { EventLogMessageResponse } from '../../../store/contextAPI/eventLogging/dto/response/event-log-message-response';

export interface UserManagementEventLoggingTemplateProps {
  data?: EventLogMessageResponse;
  actionFilter: string;
  contextTypeFilter: string;
  setActionFilter: React.Dispatch<React.SetStateAction<string>>;
  setContextTypeFilter: React.Dispatch<React.SetStateAction<string>>;
  handleReset: () => void;
  handleSearch: () => void;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  fromDate: string;
  toDate: string;
  setFromDate: React.Dispatch<React.SetStateAction<string>>;
  setToDate: React.Dispatch<React.SetStateAction<string>>;
}

const UserManagementEventLoggingTemplate: FC<
  UserManagementEventLoggingTemplateProps
> = ({
  data,
  actionFilter,
  setActionFilter,
  handleReset,
  contextTypeFilter,
  setContextTypeFilter,
  handleSearch,
  searchTerm,
  setSearchTerm,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <Label content="Event Logging" size="lg" />
        <UserManagementEventLoggingFilterOrganism
          actionFilter={actionFilter}
          contextTypeFilter={contextTypeFilter}
          setActionFilter={setActionFilter}
          setContextTypeFilter={setContextTypeFilter}
          handleReset={handleReset}
          handleSearch={handleSearch}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        <div className={cn(styles.tableWrapper)}>
          {data && <UserManagementEventLogging data={data} />}
        </div>
      </Container>
    </BaseTemplate>
  );
};

export default UserManagementEventLoggingTemplate;
